import React, { ReactNode } from "react";
import ContractPagesNavigation from "features/contracts/components/ContractPagesNavigation";
import ContractFullDTO from "features/contracts/dtos/ContractFullDTO";
import ContractEnergyDTO from "features/contracts/dtos/ContractEnergyDTO";
import { useTranslation } from "react-i18next";
import BreadcrumbLink from "features/shared/components/breadcrumbs/BreadcrumbLink";
import Header from "features/shared/layout/header/Header";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import { loadPortalConfig } from "features/shared/helpers/modules";
import { getContractDetailRoute } from "features/shared/helpers/routeHelper";

const portalConfig = loadPortalConfig();

interface Props {
  children: ReactNode;
  contract: ContractFullDTO;
  contractEnergy: ContractEnergyDTO;
  links: BreadcrumbLink[];
  showLinkToDetail?: boolean;
}

const ContractDetailLayoutPage = ({
  contract,
  contractEnergy,
  links,
  children,
  showLinkToDetail = true
}: Props) => {
  // translation
  const { t } = useTranslation("shared\\moduleNames");

  // helpers
  const getLinks = (): BreadcrumbLink[] => {
    let result: BreadcrumbLink[] = [getRootLink()];  

    if (showLinkToDetail) {
      result.push({ text: t("contractDetail.subtitle"), to: getContractDetailRoute(contract.contractId!) });
    }

    result.push(...links);

    return result;
  }

  const getRootLink = (): BreadcrumbLink => {
    if (portalConfig.useContractualAccounts) {
      return { text: t("contractualAccounts.title"), to: "/contractual-accounts" };
    } else {
      return { text: t("contracts.title"), to: "/contracts" };
    }
  }

  // render
  return (
    <>
      <Header
        title={t("contractDetail.title")}
        includeBreadcrumbs
        titleAsBreadcrumbLink={false}
        links={getLinks()}
      />
      <ModuleContent>
        <ContractPagesNavigation
          contractId={contract.contractId!}
          contractEnergy={contractEnergy}
          contractType={contract.contractType!}
          contractStatus={contract.contractStatus!}
          contractCategory={contract.contractCategory!}
          isProduction={contract.isProduction!}
        />
        {children}
      </ModuleContent>
    </>
  );
};

export default ContractDetailLayoutPage;
